import { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase-config';

const useFetchCompanyId = (selectedCompany) => {
    const [companyId, setCompanyId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCompanyId = async () => {
            setIsLoading(true);
            setError(null);

            try {
                const q = query(collection(db, "companies"), where("company", "==", selectedCompany));
                const querySnapshot = await getDocs(q);
                const companyData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))[0];

                if (companyData) {
                    setCompanyId(companyData.id);
                } else {
                    setError("Company not found");
                }
            } catch (e) {
                setError(e.message);
            } finally {
                setIsLoading(false);
            }
        };

        if (selectedCompany) {
            fetchCompanyId();
        }
    }, [selectedCompany]);

    return { companyId, isLoading, error };
};

export default useFetchCompanyId;
